import { render, staticRenderFns } from "./g6detail.vue?vue&type=template&id=5b1df841&"
import script from "./g6detail.vue?vue&type=script&lang=ts&"
export * from "./g6detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports